import styled, { css } from 'styled-components';

export const CollapsibleContainerStyled = styled.div<{collapsed: boolean, transitionDuration: number}>`
    min-height: 40px;
    display: flex;
    flex-flow: column;
    overflow-y: hidden;
    transition: ${({transitionDuration}) => transitionDuration}s;
    margin: 0px 5px 5px 5px;
    background-color: #00000022;

    > .TitleBar {
      width: 100%;
      height: 40px;
      position: relative;
      padding: 0;
      display: flex;
      flex-flow: row;
      cursor: pointer;

      > span {
        flex: 1;
        top: 0;
        margin: 5px;
        font-size: 25px;
        pointer-events: none;
      }

      > .Collapser {
        transform-origin: center;
        transition: transform ${({transitionDuration}) => transitionDuration}s;
        margin: 5px;
        transform: ${({ collapsed }) => collapsed ? 'rotate(-90deg)' : ''};
      }

      > .Extra {
        height: 40px;
      }
    }

    > .ListArea {
      flex: 1;
      overflow-x: hidden;
      ${({ collapsed, transitionDuration }) => collapsed ? css`
        overflow-y: hidden;
      ` : css`
        overflow-y: auto;
        animation: hide-scroll ${transitionDuration}s backwards;
        @keyframes hide-scroll {
          from, to { overflow-y: hidden }
        }
      `}
    }
`;